import CommomProxy from '@/components/proxy/CommomProxy'

let child_routes = [{
        path: 'asthma',
        name: 'asthma',
        component: resolve => {
            require(['@/views/healthMonth/asthma.vue'], resolve);
        },
        meta: {
            title: '泓华健康公益平台'        //哮喘
        }
    },
    {
        path: 'hepatitis',
        name: 'hepatitis',
        component: resolve => {
            require(['@/views/healthMonth/hepatitis.vue'], resolve);
        },
        meta: {
            title: '泓华健康公益平台'      //肝炎
        }
    },
    {
        path: 'hypertension',
        name: 'hypertension',
        component: resolve => {
            require(['@/views/healthMonth/hypertension.vue'], resolve);
        },
        meta: {
            title: '泓华健康公益平台'        // 高血压
        }
    },
    {
        path: 'intestina',
        name: 'intestina',
        component: resolve => {
            require(['@/views/healthMonth/intestina.vue'], resolve);
        },
        meta: {
            title: '泓华健康公益平台'      // 肠道
        }
    },
    {
        path: 'iodine',
        name: 'iodine',
        component: resolve => {
            require(['@/views/healthMonth/iodine.vue'], resolve);
        },
        meta: {
            title: '泓华健康公益平台'        //  碘
        }
    },
]

let route = [{
    path: '/healthMonth',
    component: CommomProxy,
    children: child_routes
}]

export default route


// WEBPACK FOOTER //
// ./src/router/case.js